import React, { Component } from "react";
import Modal from "react-bootstrap/Modal";
import ModalHeader from "react-bootstrap/ModalHeader";
import ModalTitle from "react-bootstrap/ModalTitle";
import ModalBody from "react-bootstrap/ModalBody";
import ModalFooter from "react-bootstrap/ModalFooter";
import ApiService from "../../../../apiService";
import AsyncSelect from "react-select/async";
import { OdontogramContext } from "../../../../context";
import ApiConsumer from "../../ApiConsumer";
import { CustomOption, CustomSingleValue } from "./selectCustomComponent";
import odontogramHelper from "./odontogramHelper";
import WindowedSelect from "react-windowed-select";
import Alert from "../../../component/Alert";
import { InlineLoading } from "../../../component/Loading";
import { toast } from "../../../component/Alert";

const customStyle = {
  dropdownIndicator: (provided) => ({
    ...provided,
    display: "none",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    display: "none",
  }),
  singleValue: (provided) => ({
    ...provided,
    fontSize: "14px",
  }),
};

class ModalOdontogram extends Component {
  static contextType = OdontogramContext;

  state = {
    field: {
      teeth_no: this.props.element,
      status_gigi: "",
      diagnosa: "",
      tindakan: "",
      teeth_ce: 1,
      teeth_ce_plus: 1,
      teeth_sondasi: 1,
      teeth_sondasi_plus: 1,
      teeth_perkusi: 1,
      teeth_perkusi_plus: 1,
      teeth_palpasi: 1,
      teeth_palpasi_plus: 1,
      log: "no",
      catatan: "",
    },
    icd: [0],
    treatments: [0],
    patient: this.context.patient,
    isLoading: false,
  };

  calenderOnChangeHandler = (date) => {
    this.setState({
      field: { ...this.state.field, tanggal: date },
    });
  };

  inputOnChangeHandler = (e) => {
    this.setState({
      field: { ...this.state.field, [e.target.name]: e.target.value },
    });
  };

  selectOnChangeHandler = (data, component) => {
    this.setState({ [component.name]: data || [] });
  };

  selectOnChangeStatusGigi = (data, component) => {
    this.setState({
      field: { ...this.state.field, [component.name]: data ? data.value : "" },
    });
  };

  teethAnamneseSubmitHandler = async (params) => {
    const res = await ApiService.post(
      "management/teeth_anamneses/create",
      params
    );
  };

  caseCheckboxHandler = (e) => {
    this.setState({
      icd: { ...this.state.icd, case: e.target.checked ? "old" : "new" },
    });
  };

  onSubmitHandler = async (e) => {
    if (!this.state.field.status_gigi) {
      toast({ status: "error", text: "Pilih status gigi dulu" });
      return;
    }

    const teethElement = this.props.element;
    const { patient, icd, treatments, field } = this.state;

    this.setState({
      isLoading: true,
    });
    const responses = await odontogramHelper.submitTeethAnamnese(
      teethElement,
      patient,
      icd,
      treatments,
      field
    );
    console.log("responses", responses);
    if (responses.isSuccess) {
      Alert("success", "Berhasil");
      this.context.handleSubmit(this.props.element);
      let dx = this.state.patient.diagnoses;
      dx.push(responses.diagnoses.data);
      this.context.parentCallback({
        data: dx,
        param: "diagnoses",
      });
      this.props.handleSubmit();
    } else {
      if (responses.diagnoses.code === 200) {
        const diagnoses = responses.diagnoses;
        this.setState({
          icd:
            diagnoses.data.length > 0
              ? [
                  {
                    value: 1,
                    label: `${diagnoses.data[0].icd_code} - ${diagnoses.data[0].icd_name}`,
                    case: diagnoses.data[0].case,
                    code: diagnoses.data[0].icd_code,
                    name: diagnoses.data[0].icd_name,
                  },
                ]
              : [],
        });
      }
      if (responses.teethAnamnese.code === 401) {
        Alert("error", "status harus diisi");
      }
    }

    this.setState({
      isLoading: false,
    });
  };

  render() {
    // console.log(this.state);
    const { field, icd, isLoading } = this.state;
    const patient = this.state.patient;

    const toothStatusDatas =
      this.context.toothStatusDatas &&
      this.context.toothStatusDatas.map((toothStatusData) => {
        return {
          value: toothStatusData.id,
          label: toothStatusData.name,
          url: toothStatusData.url,
        };
      });
    console.log(this.state);

    return (
      <>
        <Modal
          {...this.props}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          scrollable
          backdrop="static"
        >
          <ModalHeader>
            <ModalTitle id="contained-modal-title-vcenter">
              Perlakuan Gigi
            </ModalTitle>
          </ModalHeader>
          <ModalBody>
            <div className="form-group row">
              <label
                htmlFor="example-text-input"
                className="col-md-2  col-form-label col-form-label"
              >
                Nomenklatur
              </label>
              <div className="col-md-2">
                <input
                  className="form-control form-control"
                  value={field.teeth_no}
                  type="text"
                  name="teeth_no"
                  disabled={true}
                />
              </div>
            </div>
            <div className="form-group row">
              <label
                htmlFor="example-text-input"
                className="col-md-2 col-form-label col-form-label"
              >
                Status Gigi <span className="text-danger">*</span>
              </label>
              <div className="col-md-7">
                <WindowedSelect
                  components={{
                    Option: CustomOption,
                    SingleValue: CustomSingleValue,
                  }}
                  options={toothStatusDatas}
                  isClearable
                  placeholder="Pilih..."
                  name="status_gigi"
                  onChange={this.selectOnChangeStatusGigi}
                />
              </div>
            </div>
            <div className="form-group row">
              {this.state.icd?.map((v, k) => (
                <>
                  <label
                    htmlFor="example-text-input"
                    className="col-md-2 col-form-label col-form-label"
                    style={k === 0 ? {} : { color: "white" }}
                  >
                    Diagnosa
                  </label>
                  <div className="col-md-7">
                    <AsyncSelect
                      isClearable
                      cacheOptions
                      loadOptions={ApiConsumer.getIcd}
                      placeholder="Pilih..."
                      value={v || null}
                      onChange={(data) => {
                        let icd = [...this.state.icd];
                        icd[k] = data;
                        this.setState({ icd });
                      }}
                      styles={customStyle}
                      name="icd"
                      required
                    />
                  </div>
                  <div className={"col-md-2"}>
                    <div
                      className="custom-control custom-checkbox"
                      style={!v ? { display: "none" } : {}}
                    >
                      <input
                        type="checkbox"
                        className="custom-control-input"
                        id={`cs-${k}`}
                        onChange={(e) => {
                          const idx = +e.target.id.split("-")[1];
                          let icd = [...this.state.icd];
                          icd[idx] = {
                            ...icd[idx],
                            case: e.target.checked ? "old" : "new",
                          };
                          this.setState({ icd });
                        }}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor={`cs-${k}`}
                      >
                        Kasus Lama
                      </label>
                    </div>
                  </div>
                  <div className={"col-md-1 text-right"}>
                    {this.state.icd?.length > 1 && (
                      <button
                        id={`del-${k}`}
                        className={"btn btn-danger btn-sm"}
                        onClick={(e) => {
                          const idx = +e.currentTarget.id.split("-")[1];
                          let icd = [];
                          this.state.icd.forEach((x, y) => {
                            if (y !== idx) {
                              icd.push(x);
                            }
                          });
                          this.setState({ icd });
                        }}
                      >
                        <i className={"fa fa-trash"}></i>
                      </button>
                    )}
                  </div>
                </>
              ))}
              <div className="col-md-2"></div>
              <div className="col-md-10">
                <button
                  className={"btn btn-success btn-sm mt-2"}
                  onClick={() => {
                    this.setState({ icd: [...this.state.icd, 0] });
                  }}
                >
                  <i className={"fa fa-plus"}></i>
                </button>
              </div>
            </div>
            <div className="form-group row">
              {this.state.treatments?.map((v, k) => (
                <>
                  <label
                    htmlFor="example-text-input"
                    className="col-md-2 col-form-label col-form-label"
                    style={k === 0 ? {} : { color: "white" }}
                  >
                    Tindakan <span className="text-danger">*</span>
                  </label>
                  <div className="col-md-7">
                    <AsyncSelect
                      isClearable
                      cacheOptions
                      loadOptions={(inputValue) =>
                        ApiConsumer.getTreatment(
                          patient.payment_type_id,
                          inputValue
                        )
                      }
                      placeholder="Pilih..."
                      value={v || null}
                      onChange={(data) => {
                        let treatments = [...this.state.treatments];
                        treatments[k] = data;
                        this.setState({ treatments });
                      }}
                      styles={customStyle}
                      name="treatments"
                    />
                  </div>
                  <div className={"col-md-3 text-right"}>
                    {this.state.treatments?.length > 1 && (
                      <button
                        id={`del-${k}`}
                        className={"btn btn-danger btn-sm"}
                        onClick={(e) => {
                          const idx = +e.currentTarget.id.split("-")[1];
                          let treatments = [];
                          this.state.treatments.forEach((x, y) => {
                            if (y !== idx) {
                              treatments.push(x);
                            }
                          });
                          this.setState({ treatments });
                        }}
                      >
                        <i className={"fa fa-trash"}></i>
                      </button>
                    )}
                  </div>
                </>
              ))}
              <div className="col-md-2"></div>
              <div className="col-md-10">
                <button
                  className={"btn btn-success btn-sm mt-2"}
                  onClick={() => {
                    this.setState({
                      treatments: [...this.state.treatments, 0],
                    });
                  }}
                >
                  <i className={"fa fa-plus"}></i>
                </button>
              </div>
            </div>
            <div className="text-left h4 mb-4">
              Pemeriksaan IO dengan Alat :
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-3 col-form-label col-form-label"
                  >
                    CE
                  </label>
                  <div className="col-md-2">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="ce_negatif"
                        name="teeth_ce"
                        className="custom-control-input"
                        value="1"
                        onChange={this.inputOnChangeHandler}
                        defaultChecked={true}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="ce_negatif"
                      >
                        -
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="ce_positif"
                        name="teeth_ce"
                        className="custom-control-input"
                        value="2"
                        onChange={this.inputOnChangeHandler}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="ce_positif"
                      >
                        +
                      </label>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <input
                      className="form-control form-control"
                      type="text"
                      id="example-text-input"
                      name="teeth_ce_plus"
                      onChange={this.inputOnChangeHandler}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-3 col-form-label col-form-label"
                  >
                    Sondasi
                  </label>
                  <div className="col-md-2">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="sondasi_negatif"
                        name="teeth_sondasi"
                        className="custom-control-input"
                        value="1"
                        onChange={this.inputOnChangeHandler}
                        defaultChecked={true}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="sondasi_negatif"
                      >
                        -
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="sondasi_positif"
                        name="teeth_sondasi"
                        className="custom-control-input"
                        value="2"
                        onChange={this.inputOnChangeHandler}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="sondasi_positif"
                      >
                        +
                      </label>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <input
                      className="form-control form-control"
                      type="text"
                      id="example-text-input"
                      name="teeth_sondasi_plus"
                      onChange={this.inputOnChangeHandler}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-3 col-form-label col-form-label"
                  >
                    Perkusi
                  </label>
                  <div className="col-md-2">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="perkusi_negatif"
                        name="teeth_perkusi"
                        className="custom-control-input"
                        value="1"
                        onChange={this.inputOnChangeHandler}
                        defaultChecked={true}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="perkusi_negatif"
                      >
                        -
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="perkusi_positif"
                        name="teeth_perkusi"
                        className="custom-control-input"
                        value="2"
                        onChange={this.inputOnChangeHandler}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="perkusi_positif"
                      >
                        +
                      </label>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <input
                      className="form-control form-control"
                      type="text"
                      id="example-text-input"
                      name="teeth_perkusi_plus"
                      onChange={this.inputOnChangeHandler}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label
                    htmlFor="example-text-input"
                    className="col-md-3 col-form-label col-form-label"
                  >
                    Palpasi
                  </label>
                  <div className="col-md-2">
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="palpasi_negatif"
                        name="teeth_palpasi"
                        className="custom-control-input"
                        value="1"
                        onChange={this.inputOnChangeHandler}
                        defaultChecked={true}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="palpasi_negatif"
                      >
                        -
                      </label>
                    </div>
                    <div className="custom-control custom-radio custom-control-inline">
                      <input
                        type="radio"
                        id="palpasi_positif"
                        name="teeth_palpasi"
                        className="custom-control-input"
                        value="2"
                        onChange={this.inputOnChangeHandler}
                      />
                      <label
                        className="custom-control-label"
                        htmlFor="palpasi_positif"
                      >
                        +
                      </label>
                    </div>
                  </div>
                  <div className="col-md-5">
                    <input
                      className="form-control form-control"
                      type="text"
                      id="example-text-input"
                      name="teeth_palpasi_plus"
                      onChange={this.inputOnChangeHandler}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group row">
              <label
                htmlFor="example-text-input"
                className="col-md-2 col-form-label col-form-label"
              >
                Catatan
              </label>
              <div className="col-md-5">
                <textarea
                  style={{ resize: "none" }}
                  className="form-control"
                  id="example-text-input"
                  rows="2"
                  name="catatan"
                  onChange={this.inputOnChangeHandler}
                />
              </div>
            </div>
          </ModalBody>
          <ModalFooter>
            <span className={isLoading ? "" : "d-none"}>
              <InlineLoading />
            </span>
            <button
              onClick={(e) => {
                this.onSubmitHandler(e);
              }}
              className="btn btn-primary"
              disabled={this.state.isLoading}
            >
              Simpan
            </button>
            <button
              className="btn btn-danger"
              onClick={this.props.onHide}
              disabled={this.state.isLoading}
            >
              Tutup
            </button>
          </ModalFooter>
        </Modal>
      </>
    );
  }
}

export default ModalOdontogram;
